import { ISortableColumn, IUIPreferences } from '../Job/types';

export const getUpdatedSortableColumns = (
  sortableColumns: ISortableColumn[],
  columnsAndLimitPreferences: IUIPreferences
) => {
  const sortableColumnMap = new Map<string, ISortableColumn>();
  sortableColumns.forEach((column) => {
    sortableColumnMap.set(column.id, column);
  });

  const usedIds: ISortableColumn['id'][] = [];
  const updatedColumns: ISortableColumn[] = [];
  columnsAndLimitPreferences.sortable_columns.forEach((column) => {
    const matchingColumn = sortableColumnMap.get(column.id);

    if (matchingColumn) {
      updatedColumns.push({
        ...matchingColumn,
        sortable: column.sortable,
        canToggle: column.canToggle,
        enabled: column.enabled
      });
      usedIds.push(matchingColumn.id);
    }
  });
  sortableColumns.forEach((column) => {
    if (!usedIds.includes(column.id)) {
      updatedColumns.push(column);
    }
  });

  return { updatedColumns };
};
